import * as React from "react";
import { createMemoryRouter, RouterProvider, Outlet } from "react-router-dom";
import { AuthProvider, useAuthUser } from "react-auth-kit";
import { makeStyles } from "@fluentui/react-components";
import WordAgentPane from "./agent/WordAgentPane";
import SignInComponent from "../components/auth/SignIn";
import SignOut from "../components/auth/SignOutButton";
import "../styles/tailwind.css";
import "../resources/clash-display.css";
import "./App.css";
import posthog from "posthog-js";

posthog.init("phc_bdUxtNoJmZWNnu1Ar29zUtusFQ4bvU91fZpLw5v4Y3e", {
  api_host: "https://eu.i.posthog.com",
  person_profiles: "identified_only",
  bootstrap: {
    distinctID: "unknown_user",
    isIdentifiedID: false,
    featureFlags: {},
    featureFlagPayloads: {},
  },
  autocapture: false,
  loaded: (posthog) => {
    const authState = JSON.parse(localStorage.getItem("_auth_state") || "{}");
    if (authState.email) {
      posthog.identify(authState.email, {
        email: authState.email,
        app_type: "word_add_in",
        platform: "microsoft_office",
        client: "word",
      });
    } else {
      posthog.register({
        app_type: "word_add_in",
        platform: "microsoft_office",
        client: "word",
      });
    }
  },
});

interface AppProps {
  title: string;
}

const useStyles = makeStyles({
  root: {},
});

const REFRESH_INTERVAL = 24 * 60 * 60 * 1000;

const Layout: React.FC<{ title: string }> = ({ title }) => {
  const getAuth = useAuthUser();
  const auth = getAuth();

  React.useEffect(() => {
    const lastRefresh = localStorage.getItem("lastAddinRefresh");
    const now = Date.now();

    if (!lastRefresh || now - parseInt(lastRefresh) > REFRESH_INTERVAL) {
      localStorage.setItem("lastAddinRefresh", now.toString());
      window.location.reload();
    }

    if (auth?.email) {
      posthog.identify(auth.email, {
        email: auth.email,
        app_type: "word_add_in",
        platform: "microsoft_office",
        client: "word",
      });
    }

    posthog.capture("word_addin_loaded", {
      title,
      environment: "microsoft_word",
      email: auth?.email || "unknown_user",
    });
  }, [auth?.email]);

  return <Outlet />;
};

const App: React.FC<AppProps> = ({ title }) => {
  const styles = useStyles();

  const router = createMemoryRouter(
    [
      {
        path: "/",
        element: <Layout title={title} />,
        children: [
          {
            path: "/",
            element: <WordAgentPane />,
          },
          {
            path: "/login",
            element: <SignInComponent />,
          },
          {
            path: "/logout",
            element: <SignOut />,
          },
          {
            path: "*",
            element: <WordAgentPane />,
          },
        ],
      },
    ],
    {
      initialEntries: ["/"],
      initialIndex: 0,
    }
  );

  return (
    <div className={styles.root}>
      <AuthProvider authType={"localstorage"} authName={"sparkaichatbot"}>
        <RouterProvider router={router} />
      </AuthProvider>
    </div>
  );
};

export default App;
